import { INPUT } from '$gbusiness/enums';
import InputRowModel from '$gbusiness/models/inputRow';
import { input } from '$gbusiness/helpers';

export const SHIPPING_METHOD_FORM: Array<InputRowModel> = [
  {
    items: [
      {
        label: 'INPUT.LABEL.SHIPPING_METHOD',
        value: 'name',
        input: INPUT.TEXT,
        gridSize: 12,
        validation: [input.requiredValidation],
      },
    ],
  },
];
